export type ApplicationStatus =
  | 'Pending'
  | 'Submitted'
  | 'Invited'
  | 'Interviewed'
  | 'Rejected'
  | 'Hired'
  | 'Canceled'
  | 'Obsolete';

export interface StatusInfo {
  icon: string;
  label: string;
  class?: string;
}

export const APPLICATION_STATUSES: Record<ApplicationStatus, StatusInfo> = {
  Pending: {
    icon: 'bi-hourglass-split',
    label: 'Pending',
    class: 'text-warning',
  },
  Submitted: {
    icon: 'bi-envelope-check',
    label: 'Submitted',
    class: 'text-info',
  },
  Invited: {
    icon: 'bi-calendar-event',
    label: 'Invited',
    class: 'text-primary',
  },
  Interviewed: {
    icon: 'bi-check-circle',
    label: 'Interviewed',
    class: 'text-success',
  },
  Rejected: {
    icon: 'bi-x-circle',
    label: 'Rejected',
    class: 'text-danger',
  },
  Hired: {
    icon: 'bi-check-all',
    label: 'Hired',
    class: 'text-success',
  },
  Canceled: {
    icon: 'bi-x-octagon',
    label: 'Canceled',
    class: 'text-secondary',
  },
  Obsolete: {
    icon: 'bi-archive',
    label: 'Obsolete',
    class: 'text-secondary',
  },
};

/**
 * Gets all application status options in a type-safe way
 * @returns Array of all possible ApplicationStatus values
 */
export function getStatusOptions(): ApplicationStatus[] {
  return Object.keys(APPLICATION_STATUSES).map(
    (key) => key as ApplicationStatus
  );
}
